import React from "react";
import dummyProfile from '../../../Assets/images/dummyProfileIcon.png'
import badgeBlank from '../../../Assets/images/badge-blank.png'
import starfilled from '../../../Assets/images/star-filled.png'
import starEmpty from '../../../Assets/images/star-empty.png'
import { Col, Row } from "react-bootstrap";
import { RightArrowNewIcon } from "Assets/icons/v2";
import { useNavigate } from "react-router-dom";
function CaseloadSchool({ caseloadData }) {
    const navigate = useNavigate()  
    return (
         <div className="bg-white p-4 rounded-3 position-relative" style={{ border: "1px solid #C7C2B1", }}>
            <Row>
                <Col sm="9">
                    <div className="d-flex align-items-start justify-content-between school-middle h-100">
                        {/* <div>
                            <p className="caseload-label">MY SCHOOL</p>
                            <h3 className="caseload-head mt-3">
                                St. Aloysius Mungo’s Catholic <br />
                                Intermediate School
                            </h3>
                        </div> */}
                        {/* <div className="school-middle"> */}
                            <div>
                                <p className="caseload-label text-center mb-0">TOTAL CLIENTS</p>
                                <h1 className="caseload-num">{caseloadData?.total_clients}</h1>
                            </div>

                            <div className="">
                                <p className="caseload-label text-center mb-0">TASKS COMPLETED  THIS YEAR</p>
                                <h1 className="caseload-num mb-0">{caseloadData?.total_completed_this_year}</h1>
                                <p className="caseload-label text-center" style={{ color: "#8F8F8F" }}>ALL TIME: {caseloadData?.total_tasks}</p>
                            </div>
                        {/* </div> */}
                    </div>
                </Col>
                <Col sm="3">
                    <div className="d-flex flex-column gap-4 align-items-center">
                        <div className="position-relative d-flex justify-content-center">
                            <img src={badgeBlank} alt="" />
                            <div className="position-absolute bottom-0 badge-text" >No Badge Yet</div>
                        </div>

                        <div className="d-flex gap-1">
                            <img src={starfilled} alt="" />
                            <img src={starEmpty} alt="" />
                            <img src={starEmpty} alt="" />
                        </div>
                    </div>
                </Col>
            </Row>
            <button onClick={() => navigate("/my-achievements")} className="bg-transparent border-0 position-absolute end-0 top-50">
                <RightArrowNewIcon />
            </button>


        </div>
    );
}

export default CaseloadSchool;